import { Suspense, lazy } from 'react';
import Loader from '../customs/Customspinner/spinner';

const Main = lazy(() => import('../components/verification/main'));

const RequestVerification = () => {
    return (
        <Suspense fallback={<Loader/>}>        
                <Main/>    
        </Suspense>
    )
}

export default RequestVerification;